module.exports = __webpack_public_path__ + "static/img/step3_title_2_2.556db36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step3_title_2_2.png
// module id = q8Z0
// module chunks = 1